import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { IMetadataProvider } from '../../interfaces/imetadata-provider';
import { LinkService } from '../link/link.service';

declare let document;

@Injectable()
export class MetadataBuilder {
    constructor(private _metaService: Meta, private _titleService: Title, private _linkService: LinkService) {}

    public build(metaDataProvider: IMetadataProvider) {
        this.buildMetadata(metaDataProvider);
    }

    private hasOpenGraph(): boolean {
        return true;
    }

    private addOpenGraphTag(name: string, value: string) {
        if (this.hasOpenGraph()) {
            this._metaService.addTag({
                property: name,
                content: value
            });
        }
    }

    private removeTag(name: string) {
        if (name == null) {
            return;
        }
        this._metaService.removeTag('name = "' + `${name}` + '"');
    }

    private buildMetadata(provider: IMetadataProvider) {
        this.buildCommonOpenGraphTags();
        this.buildTitle(provider.getTitle());
        this.buildDescription(provider.getDescription());
        this.buildKeywords(provider.getKeywords());
        this.buildImage(provider.getImage());
        this.buildUrl(provider.getCanonicalUrl());
        this.buildRobots(provider.getRobots());
    }

    private buildCommonOpenGraphTags() {
        this.buildOpenGraphPrefix();
        this.addOpenGraphTag('og:type', 'website');
        this.addOpenGraphTag('og:locale', null);
        this.removeTag('GENERATOR');
    }

    private buildOpenGraphPrefix() {
        if (!this.hasOpenGraph()) {
            return;
        }
        let doc;
        try {
            doc = document;
        } catch (ex) {}

        if (doc != null) {
            doc.documentElement.setAttribute('prefix', 'og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# website: http://ogp.me/ns/website#');
        }
    }

    private buildTitle(title: string) {
        if (title == null || title.length === 0) {
            return;
        }
        this._titleService.setTitle(title);
        this.addOpenGraphTag('og:title', title);
    }

    private buildDescription(description: string) {
        if (description == null || description.length === 0) {
            return;
        }
        this._metaService.addTag({
            name: 'description',
            content: description
        });
        this.addOpenGraphTag('og:description', description);
    }

    private buildKeywords(keywords: string) {
        if (keywords == null || keywords.length === 0) {
            return;
        }
        this.addOpenGraphTag('og:keywords', keywords);
    }

    private buildImage(image: string) {
        if (image == null || image.length === 0) {
            return;
        }
        this.addOpenGraphTag('og:image', image);
    }

    private buildUrl(canonicalUrl: string) {
        if (canonicalUrl == null || canonicalUrl.length === 0) {
            // remove canonical from sharepoint
            const canonical = document.querySelector('[rel="canonical"]');
            if (canonical) {
                canonical.parentNode.removeChild(canonical);
            }
            return;
        }
        this.addOpenGraphTag('og:url', canonicalUrl);
        this._linkService.addTag({ rel: 'canonical', href: canonicalUrl });
    }

    private buildRobots(robots: string) {
        if (robots == null || robots.length === 0) {
            return;
        }
        this._metaService.addTag({
            name: 'robots',
            content: robots
        });
    }
}
